import cn from 'classnames';

import { togglePage } from '../../helpers/togglePage';
import { SIX_IN_TIX_LIST } from '../../constants/sixInTixList';

import './SixNavbar.scss';
import { Sections } from '../../types/Sections';
import { isSixInHash } from '../../helpers/isSixInHash';
import { MenuItems } from '../../types/MenuItems';

export const SixNavbar = () => {
  const { hash } = window.location;

  const handleBtnClick = (item: MenuItems) => {
    togglePage(`#${item}`);
  };

  return (
    <nav
      className={cn('six-navbar', {
        'six-navbar__visible':
          hash.includes(Sections.SIXINTIX) || isSixInHash(),
      })}
      id="six-navbar"
    >
      {SIX_IN_TIX_LIST.map((item) => (
        <button
          key={item}
          className={cn(
            `six-navbar__button ${item}-bg menu-button _blockLogoHover`,
            {
              [`menu-button--active`]: hash.includes(item),
            },
          )}
          onClick={() => handleBtnClick(item)}
        >
          <span>{item}</span>
        </button>
      ))}
    </nav>
  );
};
